import { useAuthContext } from '@/hooks/useAuthContext';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { Container, Stack, Typography } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import esLocale from '@fullcalendar/core/locales/es'; // Importa el idioma español
import { useQuery } from '@tanstack/react-query';
import { getShifts } from '@/services/shift';
import dayjs from 'dayjs';

export const CalendarPage = () => {
  const { user } = useAuthContext();

  const {data,isLoading} = useQuery({
    queryKey: ['events', user?.uid!],
    queryFn: getShifts(user?.uid!),

    select: (data) => {
      return data.map((item: any) => {

        const lastTime = dayjs(item.startTime,'hh:mma').add(item.hours,'hours').format('hh:mma').toString();


        return {
          title: 'Turno',
          start: item.date,
          extendedProps: {
            hours: `${item.startTime} - ${lastTime}`,
          },
        };
      });

    }
  });


  return (
    <>
      <Helmet>
        <title>Calendario</title>
      </Helmet>
      <Container>
        <Stack sx={{ marginY: '3rem', display: 'flex', flexDirection: 'colum', gap: '1rem' }}>
          <Typography variant="h5">Calendario</Typography>
          <Typography variant="h5">Usuario : {user?.displayName}</Typography>
        </Stack>

        <Stack>
          <FullCalendar
            plugins={[dayGridPlugin]}
            initialView="dayGridMonth"
            events={data}
            eventContent={renderEventContent}
            locale={esLocale}
          />
        </Stack>
      </Container>
    </>
  );
};

function renderEventContent(eventInfo: any) {
  return (
    <div>
      <p style={{ fontWeight: 'bold' }}> {eventInfo.event.title}</p>
      <p> {eventInfo.event.extendedProps.hours}</p>
    </div>
  );
}
export default CalendarPage;
